import { styled, css } from 'styled-components';
export const Wrapper = styled.div `
  display: grid;
  grid-template-columns: repeat(${({ numberOfColumns }) => numberOfColumns}, 1fr);
`;
export const Item = styled.button.attrs(() => ({
    type: 'button',
})) `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 8px 16px;
  height: 36px;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ theme, disabled, checked }) => {
    if (checked && disabled)
        return theme.colors.grey70_1;
    if (!checked && disabled)
        return theme.colors.grey05_3;
    return theme.colors.grey30_1;
}};
  box-sizing: border-box;

  &:first-child {
    border-radius: 8px 0 0 8px;
  }
  &:not(:disabled) + &:not(:disabled) {
    border-left-width: 0;
  }
  &:last-child {
    border-radius: 0 8px 8px 0;
  }

  background: ${({ checked, disabled, theme }) => {
    if (checked && disabled)
        return theme.colors.grey70_1;
    if (!checked && disabled)
        return theme.colors.grey05_3;
    return theme.colors.grey00_1;
}};
  color: ${({ checked, disabled, theme }) => {
    if (checked && disabled)
        return theme.colors.grey30_1;
    if (!checked && disabled)
        return theme.colors.grey70_3;
    if (checked && !disabled)
        return theme.colors.black_1;
    return theme.colors.grey100_1;
}};

  &:after {
    content: '';
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: ${({ checked, disabled, theme }) => {
    if (checked && disabled)
        return theme.colors.grey70_1;
    if (checked && !disabled)
        return theme.colors.main;
    return '';
}};
  }

  &:hover {
    ${({ checked, disabled }) => checked
    ? css `
            cursor: ${disabled ? 'not-allowed' : 'default'};
          `
    : css `
            cursor: ${disabled ? 'not-allowed' : 'pointer'};
          `}
  }

  &:focus-visible {
    ${({ theme }) => theme.shadows.focus}
    outline: 0;
  }

  ${({ theme }) => theme.typography.textMedium};
  ${({ theme }) => theme.typography.weightMedium}
`;
